<div class="card card-nc" *ngIf="hasEntitlement('SHIPS_ROUNDTRIPS_OVERVIEW')">
  <div class="card-heading">
    <i class="fa fa-ship"></i>
    <span class="cardHeaderHeading"> Fleet Information </span>
    <span class="pull-right save-panel">
        <button
          *ngIf="hasEntitlement('SHIPS_ROUNDTRIPS_UPDATE')"
          type="button"
          [disabled]="save_fl_btn"
          (click)="saveFleetInformation()"
          class="btn btn-nc">
          SAVE <i [ngClass]="save_fl_btn_spinner"></i>
        </button>
    </span>
  </div>
  <div class="card-body" *ngIf="ship">
    <form name="roundTripForm" [formGroup]="roundTripForm">
      <div class="row">
        <div class="col-md-3">
          <div class="row rightLeftPad">
            <label for="homePort" class="col-md-12 control-label labelCommon"> Home Port </label>
            <div class="form-group col-md-12" *ngIf="hasEntitlement('SHIPS_ROUNDTRIPS_UPDATE')">
              <input
                type="text"
                class="form-control input-sm"
                id="homePort"
                formControlName="port"
                maxlength="100"/>
              <span *ngIf="!roundTripForm.get('port').valid && roundTripForm.get('port').touched">
                <span *ngIf="roundTripForm.get('port').errors['invalidHomePort']"
                      class="help-block has-error validationMessage">
                  Only alphabets,numbers,-,. are allowed for home port
                </span>
                <span
                  class="help-block has-error validationMessage"
                  *ngIf="roundTripForm.get('port').errors['required']">
                  Required
                </span>
              </span>
            </div>
            <div class="form-group col-md-12 staticText1" *ngIf="!hasEntitlement('SHIPS_ROUNDTRIPS_UPDATE')">
              {{ship.shipPort}}
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="row rightLeftPad">
            <label for="dssn" class="col-md-12 control-label labelCommon"> DSSN </label>
            <div class="form-group col-md-12" *ngIf="hasEntitlement('SHIPS_ROUNDTRIPS_UPDATE')">
              <input
                type="text"
                class="form-control input-sm"
                id="dssn"
                formControlName="dssn"
                maxlength="4"/>
              <span *ngIf="!roundTripForm.get('dssn').valid && roundTripForm.get('dssn').touched">
                <span *ngIf="roundTripForm.get('dssn').errors['invalidDssn']"
                      class="help-block has-error validationMessage">
                  DSSN should be a 4 digit number
                </span>
                <span
                  class="help-block has-error validationMessage"
                  *ngIf="roundTripForm.get('dssn').errors['required']">
                  Required
                </span>
              </span>
            </div>
            <div class="form-group col-md-12 staticText1" *ngIf="!hasEntitlement('SHIPS_ROUNDTRIPS_UPDATE')">
              {{ship.dssn}}
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="row rightLeftPad">
            <label for="tycom" class="col-md-12 control-label labelCommon"> TYCOM </label>
            <div class="form-group col-md-12" *ngIf="hasEntitlement('SHIPS_ROUNDTRIPS_UPDATE')">
              <input
                type="text"
                class="form-control
                input-sm" id="tycom"
                formControlName="tycom"
                maxlength="10"/>
              <span *ngIf="!roundTripForm.get('tycom').valid &&
                            roundTripForm.get('tycom').touched &&
                            roundTripForm.get('tycom').errors['required']"
                class="help-block has-error validationMessage">
                Required
               </span>
            </div>
            <div class="form-group col-md-12 staticText1" *ngIf="!hasEntitlement('SHIPS_ROUNDTRIPS_UPDATE')">
              {{ship.shipTycom}}
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="row rightLeftPad">
            <label for="cinc" class="col-md-12 control-label labelCommon"> CINC </label>
            <div class="form-group col-md-12" *ngIf="hasEntitlement('SHIPS_ROUNDTRIPS_UPDATE')">
              <input
                type="text"
                class="form-control input-sm"
                id="cinc"
                formControlName="cinc"
                maxlength="6" />
              <span *ngIf="!roundTripForm.get('cinc').valid &&
                            roundTripForm.get('cinc').touched &&
                            roundTripForm.get('cinc').errors['required']"
                class="help-block has-error validationMessage">
                Required
               </span>
            </div>
            <div class="form-group col-md-12 staticText1" *ngIf="!hasEntitlement('SHIPS_ROUNDTRIPS_UPDATE')">
              {{ship.shipCinc}}
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

